var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkipBack = function SvgSkipBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.154 14.688-1.443.66a.49.49 0 0 1-.196.05c-.203 0-.4-.147-.587-.44a.974.974 0 0 1-.183-.453c0-.228.192-.432.575-.612l2.52-1.137c.17-.073.352-.11.537-.11.318 0 .477.147.477.44v6.935c.003.325-.09.645-.269.917a.738.738 0 0 1-.587.416c-.204 0-.416-.159-.636-.477a1.029 1.029 0 0 1-.208-.501v-5.688ZM21.755 17.324c0 1.694-.53 2.955-1.467 3.58a2.985 2.985 0 0 1-4.408-1.429 5.598 5.598 0 0 1-.373-2.15v-.65c0-1.693.541-2.954 1.478-3.591a2.883 2.883 0 0 1 1.646-.469 2.845 2.845 0 0 1 2.763 1.91c.254.688.377 1.418.36 2.15v.65Zm-1.635-.552c0-1.742-.492-2.607-1.489-2.607-.997 0-1.49.865-1.49 2.607v.456c0 1.742.493 2.607 1.49 2.607s1.49-.864 1.49-2.607v-.456Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 17a11 11 0 1 0 22 0c0-6.075-5-11-12-11H7m0 0 3-3M7 6l3 3"
  })));
};
export default SvgSkipBack;